module.exports = __webpack_public_path__ + "static/media/1230_Music_Country_HL.d76d3f42.png";